import { Button, message } from "antd";
import { ReactComponent as CopyIcon } from "../../common/images/svg/copy.svg";

interface Props {
  value: string;
}

export const CopyButton = ({ value }: Props) => {
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(value);
      message.success('Copied to clipboard');
    } catch (error) {
      message.error('Failed to copy to clipboard');
    }
  };

  return (
    <Button
      className={"list-button"}
      icon={<CopyIcon style={{ fontSize: "12px" }} />}
      size="small"
      onClick={copyToClipboard}
    />
  );
};
